module.exports = __webpack_public_path__ + "img/providers_hero.4a0d0f8d.jpg";